import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { addDynamicEntity } from '@adornis/baseql/metadata/dynamic.js';
import { HTML } from '@adornis/cms/db/scalars.js';

// Base class for all buildify content keys
@Entity()
export class BuildifyContentKey extends AdornisEntity {
  static override _class = 'BuildifyContentKey';
}

@Entity()
export class BuildifyContent extends MongoEntity {
  static override _class = 'BuildifyContent';
  static override _collectionName = 'buildify-content';

  @Field(type => HTML)
  html!: string;

  @Field(type => BuildifyContentKey)
  key!: BuildifyContentKey;
}

// Helper function to create BuildifyContentKey subclasses
function bck(className: string, fieldName: string, fieldType: () => any) {
  const KeyClass = class extends BuildifyContentKey {
    static override _class = className;
  };

  addDynamicEntity(KeyClass, { [fieldName]: { type: fieldType, options: {} } }, {});

  return KeyClass as typeof BuildifyContentKey & { new (props: any): BuildifyContentKey };
}

// define 'key' classes for BuildifyContentTypes (use mixins to make the declaration less verbose)
// prettier-ignore
export const bcKey = {
  // Institution
  InstitutionProductPage: bck('BuildifyInstitutionProductPage', 'institutionID', () => String),
  InstitutionProductPageWorkshopCard: bck('BuildifyInstitutionProductPageWorkshopCard', 'institutionID', () => String),
  InstitutionProductPageCounselingCard: bck('BuildifyInstitutionProductPageCounselingCard', 'institutionID', () => String),
  InstitutionProductPageWorkshopSetCard: bck('BuildifyInstitutionProductPageWorkshopSetCard', 'institutionID', () => String),
  
  // Workshop
  WorkshopDetailPage: bck('BuildifyWorkshopDetailPage', 'workshopID', () => String),
  
  // Einzelberatung
  EinzelberatungDetailPage: bck('BuildifyEinzelberatungDetailPage', 'einzelberatungID', () => String),
  
  // LecturerData
  LecturerDataDetailPage: bck('BuildifyLecturerDataDetailPage', 'lecturerDataID', () => String),
  
  // GlobalSetting
  GlobalSettingInstitutionOverview: bck('BuildifyGlobalSettingInstitutionOverview', 'settingsID', () => String),
}
